import React from 'react';
import clsx from 'clsx';
import { LoadingBlockProps } from './types';
import { styles } from './styles';
import { Spinner } from '../Spinner';

export const LoadingBlock: React.FC<LoadingBlockProps> = ({
  size = 'lg',
  label = 'Loading...',
  className,
}) => (
  <div className={clsx(styles.container, className)}>
    <Spinner size={size} className={styles.spinner} />
    {label && <span className={styles.label}>{label}</span>}
  </div>
);

export type { LoadingBlockProps } from './types';
export default LoadingBlock;
